export const convertNoHyphenDateToValidDate = (val: string): string => {
  try {
    return `${val.replace(/(\d+)(\d{2})(\d{2})/g, "$1-$2-$3")}`;
  } catch {
    return "";
  }
};
